<template>
  <div class="hello">
    <div id="topHeader">
      <div class="topHeader">
        <div class="header min_w1200 newFlex">
          <div class="w1200 flex1">
            <div class="flex left">
              <div class="flex">
                <img src="/img/tel.png" /><span
                  >购买咨询</span
                >
              </div>
              <p
                class="holiday-phone"
                id="headerphone"
                v-for="(item, index) in settings.tel"
                :key="index"
              >
                {{ item }}
              </p>

              <p></p>
            </div>
          </div>
        </div>
        <div class="header-wrap-box">
          <div class="header-wrap">
            '
            <div class="header-box">
              <a class="go-next logo">
                <el-image
                  class=""
                  style="width: 100%; height: 100%"
                  :src="settings.logo"
                  :fit="'contain'"
                ></el-image
              ></a>

              <ul class="header-nav">
                <li v-for="(item, index) in navInfo" :key="index">
                  <a
                    class="go-next"
                    :href="
                      item.children.length > 0
                        ? 'javascript:void(0);'
                        : addOrgToUrl(item.url, 'qiyeId', GetUrlParam('qiyeId'))
                    "
                    :target="item.children.length > 0 ? '' : '_blank'"
                    >{{ item.name }}</a
                  >
                  <ol class="nav-ol" v-if="item.children.length > 0">
                    <li v-for="(chil, index2) in item.children" :key="index2">
                      <a
                        class="go-next"
                        target="_blank"
                        :href="
                          addOrgToUrl(chil.url, 'qiyeId', GetUrlParam('qiyeId'))
                        "
                        >{{ chil.name }}</a
                      >
                    </li>
                  </ol>
                </li>

                <!-- <li class="btn-code-box">
                  <a class="btn login-code btn-code">扫码试用</a>
                  <div class="qrcode">
                    <img src="https://www.wsgjp.com/img/QRcode.jpg" />
                  </div>
                </li>
                <li>
                  <a
                    class="btn register go-next"
                    href="javascript:;"
                    data-target="_blank"
                    data-url="https://register.wsgjp.com.cn/Register.aspx?ref=top"
                    >免费注册</a
                  >
                </li> -->
              </ul>
              <ul class="header-right-box">
                <li>
                  <router-link
                    class="btn login go-next"
                    :to="{ path: '/dologin' }"
                  >
                    登录
                  </router-link>
                </li>
                <li>
                  <router-link class="btn register go-next" :to="{ path: '/resign' }"
                    >免费注册 </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div> 
      </div>
      <div class="hideHeaders"></div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Nav",
  props: {
    navInfo: Array,
    settings: Object,
  },
  data() {
    return {};
  },
  mounted: function () {
    this.$nextTick(function () {
      $(".btn-code").mouseover(function () {
        $(".qrcode").fadeIn(200);
      });
      $(".login-li .login").css({ display: "none" });
      $(".btn-code-box").removeClass("hidden");

      $(".btn-code").mouseout(function () {
        $(".qrcode").fadeOut(200);
      });
    });
  },
  methods: {
    addOrgToUrl(url, paramName, replaceWith) {
      //url字符串添加参数
      //url:路径地址 paramName：参数名 replaceWith：参数值
      if (url.indexOf(paramName) > -1) {
        var re = eval("/(" + paramName + "=)([^&]*)/gi");
        url = url.replace(re, paramName + "=" + replaceWith);
      } else {
        var paraStr = paramName + "=" + replaceWith;

        var idx = url.indexOf("?");
        if (idx < 0) url += "?";
        else if (idx >= 0 && idx != url.length - 1) url += "&";
        url = url + paraStr;
      }
      return url;
    },
    GetUrlParam(paraName) {
      var url = window.location.toString();
      var arrObj = url.split("?");

      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
  },
};
</script>
